import companiesService from '@/services/companies.service'

export default {
  namespaced: true,
  state: {
    companies: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_COMPANIES(state, companies) {
      state.companies = companies
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_COMPANY(state, company) {
      state.companies.push(company)
    },
    UPDATE_COMPANY(state, updatedCompany) {
      const index = state.companies.findIndex(c => c.id === updatedCompany.id)
      if (index !== -1) {
        state.companies.splice(index, 1, updatedCompany)
      }
    },
    REMOVE_COMPANY(state, id) {
      state.companies = state.companies.filter(c => c.id !== id)
    }
  },
  actions: {
    async fetchCompanies({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await companiesService.getAll()
        // Handle paginated response - data is nested in response.data.data
        const companies = response.data?.data || response.data || []
        commit('SET_COMPANIES', companies)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createCompany({ commit }, companyData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await companiesService.create(companyData)
        if (response.success) {
          commit('ADD_COMPANY', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateCompany({ commit }, { id, companyData }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await companiesService.update(id, companyData)
        if (response.success) {
          commit('UPDATE_COMPANY', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteCompany({ commit }, id) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await companiesService.delete(id)
        if (response.success) {
          commit('REMOVE_COMPANY', id)
          return { success: true }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    allCompanies: state => state.companies,
    activeCompanies: state => state.companies.filter(c => c.active),
    isLoading: state => state.loading
  }
}

